import React from "react";
import AlertMessage from "../../components/alerts";
import LeftPanel from "../../components/leftpanel";
import TopHeader from "../../components/header";
import MyleadsMain from "../../components/myleads";

const Myleads = () => {
    return (
        <div id="container">
            <TopHeader />
            <div className="sidebar-mini">
                <LeftPanel />
                <div id="message-container">
                    <AlertMessage />
                </div>
                <div className="main-content">
                    <div className="myleads-page main-container container">
                        <MyleadsMain />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Myleads;